{"schemaVersion":1,"release":{"version":"1.1.8","build":170,"url":"https://cdn.gab.ai/macos/updates/installers/Gab-AI-1.1.8-170.dmg","sha256":"7e4774af34d02475c9c2f34c2547028a3ebd506f1bc1588a04895862e54cf9a5","size":29428436}}
